import IPromoCodeProviderElements from './IPromoCodeProviderElements';

const find = <E extends Element = Element>(selector: string) => document.querySelector(selector) as E;

export default {
  getAll: () => ({
    $form: find<HTMLFormElement>('.tn-utility-nav-inline-promo-code-form'),
    $input: find<HTMLInputElement>('#tn-utility-nav-inline-promo-code-form-input'),
    $helpBlock: find<HTMLDivElement>('#tn-utility-nav-inline-promo-code-form-help-block'),
    $helpBlockContainer: find<HTMLDivElement>('.tn-utility-nav-inline-promo-code-form__help-block-container'),
    $helpBlockText: find<HTMLDivElement>('.tn-utility-nav-inline-promo-code-form__help-block-text'),
    $btn: find<HTMLButtonElement>('.tn-utility-nav-inline-promo-code-form__btn-submit'),
    $btnApplySubmitLabel: find<HTMLSpanElement>('.tn-utility-nav-inline-promo-code-form__btn-submit-label'),
    $label: find<HTMLSpanElement>('.tn-utility-nav-applied-promo__btn-remove-label'),
    $btnRemove: find<HTMLButtonElement>('.tn-utility-nav-applied-promo__btn-remove'),
    $btnShowModal: find<HTMLButtonElement>('.tn-utility-nav-modal-promo-code-form__btn-open-modal'),
    $mobileForm: find<HTMLFormElement>('#tn-utility-nav-modal-promo-code-form'),
  }),
} as IPromoCodeProviderElements;
